import { createSlice } from '@reduxjs/toolkit';

interface InitialStateProps {
  list: {
    isLoading: boolean;
    hits: any[] | null;
    total: number | null;
    error: string | null;
  };
  current: {
    isLoading: boolean;
    data: Record<string, any> | null;
    error: string | null;
  };
  request: {
    isLoading: boolean;
    error: string | null;
  };
}

const initialState: InitialStateProps = {
  list: {
    isLoading: false,
    hits: null,
    total: null,
    error: null,
  },
  current: {
    isLoading: false,
    data: null,
    error: null,
  },
  request: {
    isLoading: false,
    error: null,
  },
};

export const { actions: appealActions, reducer: appealReducer } = createSlice({
  name: 'Appeal',
  initialState,
  reducers: {
    //List
    setAppealListRequest: (state) => {
      state.list = {
        isLoading: true,
        hits: null,
        total: null,
        error: null,
      };
    },
    setAppealListSuccess: (state, { payload }) => {
      state.list = {
        isLoading: false,
        hits: payload.hits,
        total: payload.total,
        error: null,
      };
    },
    setAppealListFailure: (state, { payload }) => {
      state.list = {
        isLoading: false,
        hits: null,
        total: null,
        error: payload.message,
      };
    },
    setAppealListDefault: (state) => {
      state.list = {
        isLoading: false,
        hits: null,
        total: null,
        error: null,
      };
    },

    setAppealCurrentRequest: (state) => {
      state.current = {
        isLoading: true,
        data: null,
        error: null,
      };
    },

    setAppealCurrentSuccess: (state, { payload }) => {
      state.current = {
        isLoading: false,
        data: payload,
        error: null,
      };
    },

    setAppealCurrentFailure: (state, { payload }) => {
      state.current = {
        isLoading: false,
        data: null,
        error: payload.message,
      };
    },

    setAppealCurrentDefault: (state) => {
      state.current = {
        isLoading: false,
        data: null,
        error: null,
      };
    },

    setNewAppealRequest: (state) => {
      state.request = {
        isLoading: true,
        error: null,
      };
    },
    setNewAppealSuccess: (state) => {
      state.request = {
        isLoading: false,
        error: null,
      };
    },
    setNewAppealFailure: (state, { payload }) => {
      state.request = {
        isLoading: false,
        error: payload.message,
      };
    },
    setNewAppealDefault: (state) => {
      state.request = {
        isLoading: true,
        error: null,
      };
    },

    setAppealConfirmRequest: (state) => {
      state.request = {
        isLoading: true,
        error: null,
      };
    },
    setAppealConfirmSuccess: (state) => {
      state.request = {
        isLoading: false,
        error: null,
      };
    },
    setAppealConfirmFailure: (state, { payload }) => {
      state.request = {
        isLoading: false,
        error: payload.message,
      };
    },

    setAppealDeclineRequest: (state) => {
      state.request = {
        isLoading: true,
        error: null,
      };
    },
    setAppealDeclineSuccess: (state) => {
      state.request = {
        isLoading: false,
        error: null,
      };
    },
    setAppealDeclineFailure: (state, { payload }) => {
      state.request = {
        isLoading: false,
        error: payload.message,
      };
    },

    setAppealRequest: (state) => {
      state.request = {
        isLoading: true,
        error: null,
      };
    },
    setAppealSuccess: (state) => {
      state.request = {
        isLoading: false,
        error: null,
      };
    },
    setAppealFailure: (state, { payload }) => {
      state.request = {
        isLoading: false,
        error: payload.message,
      };
    },
    setAppealDefault: (state, { payload }) => {
      state.request = {
        isLoading: false,
        error: null,
      };
    },
  },
});
